import {
	ADD_AP_RESULT,
	AP_ADD_FAIL,
	AP_ADD_SNAPSHOT,
	AP_ADD_SNAPSHOT_FAIL,
	AP_ADD_SNAPSHOT_SUCCESS,
	AP_ADD_SUCCESS,
	AP_ADD_TRIGGER,
	AP_BLINK,
	AP_BLINK_FAIL,
	AP_BLINK_SUCCESS,
	AP_DELETE_FAIL,
	AP_DELETE_SUCCESS,
	AP_FIRMWARE_GET_FAIL,
	AP_FIRMWARE_GET_SUCCESS,
	AP_FIRMWARE_REQUEST_GET,
	AP_LIST_GET_FAIL,
	AP_LIST_GET_SUCCESS,
	AP_LIST_REQUEST_GET,
	AP_REBOOT,
	AP_REBOOT_FAIL,
	AP_REBOOT_SUCCESS,
	AP_REMOTE_ENABLE,
	AP_REMOTE_ENABLE_FAIL,
	AP_REMOTE_ENABLE_SUCCESS,
	AP_REQUEST_ADD,
	AP_REQUEST_DELETE,
	AP_REQUEST_UPDATE,
	AP_UPDATE_FAIL,
	AP_UPDATE_SUCCESS,
	BULK_ADD_AP_RESPONSE_SUCCESS,
	BULK_AP_REQUEST_POST,
	BULK_AP_RESPONSE_POST_FAIL,
	CRITICAL_ALARM_TRIGGER,
	POST_MOVE_AP,
	POST_MOVE_AP_FAIL,
	POST_MOVE_AP_SUCCESS,
	RESET_AP_ADD,
	RESET_AP_DELETE,
	RESET_AP_UPDATE,
	RESET_BULK_ADD_AP,
	RESET_MOVE_AP,
	DEVICE_REQUEST_BY_SITE_GET,
	DEVICE_RESPONSE_BY_SITE_GET_SUCCESS,
	DEVICE_RESPONSE_BY_SITE_GET_FAIL,
	APSWITCH_REQUEST_GET,
	APSWITCH_RESPONSE_GET_SUCCESS,
	APSWITCH_RESPONSE_GET_FAIL,
	AP_DASH_DOWNLOAD,
	AP_DASH_DOWNLOAD_SUCCESS,
	GET_AP_CONFIG_REQUEST,
	GET_AP_CONFIG_REQUEST_SUCCESS,
	GET_AP_CONFIG_REQUEST_FAIL,
	DOWNLOAD_AP_CONFIG_REQUEST,
	DOWNLOAD_AP_CONFIG_REQUEST_SUCCESS,
	DOWNLOAD_AP_CONFIG_REQUEST_FAIL,
	RESET_AP_CONFIG_DATA,
	RESET_DOWNLOAD_CONFIG_DATA,
	CRITICAL_ALARM_TRIGGER_HOME,
	CRITICAL_ALARM_TRIGGER_AP,
	CRITICAL_ALARM_TRIGGER_SWITCH,
	RESET_STATE,
	SHOW_AP_MODAL,
	CONFIG_AUDIT_LIST_REQUEST_GET,
	CONFIG_AUDIT_LIST_GET_SUCCESS,
	CONFIG_AUDIT_LIST_GET_FAIL,
	ALARM_SUMMARY_VIEW_ALL_TRIGGER,
    CHILD_LIST_REQUEST_BY_SITE_GET,
	CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS,
	CHILD_LIST_RESPONSE_BY_SITE_GET_FAIL
} from '../constants/accessPointConstants';
import { UI_STATES } from '../constants/commonConstants';

/**
 * Reducer function for managing group list state.
 *
 * This reducer handles actions related to fetching group data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the group list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const accessPointListReducer = (
	state = { apList: {}, addApResp: {} },
	action
) => {
	switch (action.type) {
		case AP_REMOTE_ENABLE:
			return {
				...state,
				apRemoteEnableState: UI_STATES.LOADING,
			};
		case AP_REMOTE_ENABLE_SUCCESS:
			return {
				...state,
				apRemoteEnableState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case AP_REMOTE_ENABLE_FAIL:
			return {
				...state,
				apRemoteEnableState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case AP_ADD_SNAPSHOT:
			return {
				...state,
				apAddSnapshotState: {
					status: UI_STATES.LOADING,
				},
			};
		case AP_ADD_SNAPSHOT_SUCCESS:
			return {
				...state,
				apAddSnapshotState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case AP_ADD_SNAPSHOT_FAIL:
			return {
				...state,
				apAddSnapshotState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case AP_REBOOT:
			return {
				...state,
				apRebootState: {
					status: UI_STATES.LOADING,
				},
			};
		case AP_REBOOT_SUCCESS:
			return {
				...state,
				apRebootState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
					cmdType: action.cmdType,
				},
			};
		case AP_REBOOT_FAIL:
			return {
				...state,
				apRebootState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
					cmdType: action.cmdType,
				},
			};
		case AP_BLINK:
			return {
				...state,
				apBlinkState: {
					status: UI_STATES.LOADING,
				},
			};
		case AP_BLINK_SUCCESS:
			return {
				...state,
				apBlinkState: {
					status: UI_STATES.SUCCESS,
					data: action.payload,
				},
			};
		case AP_BLINK_FAIL:
			return {
				...state,
				apBlinkState: {
					status: UI_STATES.FAILURE,
					error: action.payload,
				},
			};
		case AP_LIST_REQUEST_GET:
			return {
				...state,
				loading: true,
				apList: [],
			};
		case AP_LIST_GET_SUCCESS:
			return {
				...state,
				loading: false,
				apList: action.payload,
			};
		case AP_LIST_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_AP_RESULT:
			return {
				...state,
				addApResp: action.payload,
			};
		case AP_FIRMWARE_REQUEST_GET:
			return {
				...state,
				apFirmwareAndModelsState: {
					status: UI_STATES.LOADING,
				},
			};
		case AP_FIRMWARE_GET_FAIL:
			return {
				...state,
				loading: false,
				apFirmwareAndModelsState: {
					error: action.payload,
					status: UI_STATES.FAILURE,
					data: null,
				},
			};
		case AP_FIRMWARE_GET_SUCCESS:
			return {
				...state,
				apFirmwareAndModelsState: {
					status: UI_STATES.SUCCESS,
					data: action.payload.data,
				},
			};
		case RESET_STATE:
			return {
				...state,
				apRemoteEnableState: {},
				apAddSnapshotState: {},
				apRebootState: {},
				apBlinkState: {},
			};
		default:
			return state;
	}
};

export const bulkAddApReducer = (
	state = { status: null, error: null, data: [] },
	action
) => {
	switch (action.type) {
		case BULK_AP_REQUEST_POST:
			return {
				...state,
				loading: true,
				error: null,
				status: UI_STATES.LOADING,
			};
		case BULK_AP_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
				status: UI_STATES.FAILURE,
			};
		case BULK_ADD_AP_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
				status: UI_STATES.SUCCESS,
				msg: action.msg,
			};
		case RESET_BULK_ADD_AP:
			return {
				...state,
				status: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};

export const accessPointDeleteReducer = (
	state = { status: null, error: null, data: [], apDeleteLength: 0 },
	action
) => {
	switch (action.type) {
		case AP_REQUEST_DELETE:
			return {
				...state,
				status: UI_STATES.LOADING,
				error: null,
			};
		case AP_DELETE_SUCCESS:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				data: action.payload,
				msg: action.msg,
				apDeleteLength: action.length,
			};
		case AP_DELETE_FAIL:
			return {
				...state,
				status: UI_STATES.FAILURE,
				error: action.payload,
			};
		case RESET_AP_DELETE:
			return {
				...state,
				status: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};

export const accessPointAddReducer = (
	state = { status: null, error: null, data: [] },
	action
) => {
	switch (action.type) {
		case AP_REQUEST_ADD:
			return {
				...state,
				status: UI_STATES.LOADING,
				error: null,
			};
		case AP_ADD_SUCCESS:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				data: action.payload,
			};
		case AP_ADD_FAIL:
			return {
				...state,
				status: UI_STATES.FAILURE,
				error: action.payload,
			};
		case RESET_AP_ADD:
			return {
				...state,
				status: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};

export const accessPointUpdateReducer = (
	state = { status: null, error: null, data: [] },
	action
) => {
	switch (action.type) {
		case AP_REQUEST_UPDATE:
			return {
				...state,
				status: UI_STATES.LOADING,
				error: null,
			};
		case AP_UPDATE_SUCCESS:
			return {
				...state,
				status: UI_STATES.SUCCESS,
				data: action.payload.data,
				msg: action.payload.msg,
			};
		case AP_UPDATE_FAIL:
			return {
				...state,
				status: UI_STATES.FAILURE,
				error: action.payload,
			};
		case RESET_AP_UPDATE:
			return {
				...state,
				status: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};
export const apTriggerReducer = (state = { apAddTrigger: false }, action) => {
	switch (action.type) {
		case AP_ADD_TRIGGER:
			return {
				...state,
				apAddTrigger: action.payload,
			};
		case SHOW_AP_MODAL:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};

export const moveApReducer = (
	state = { successMsg: '', errorMessage: '' },
	action
) => {
	switch (action.type) {
		case POST_MOVE_AP:
			return {
				...state,
				loading: true,
			};
		case POST_MOVE_AP_SUCCESS:
			return {
				...state,
				loading: false,
				successMsg: action.payload,
			};
		case POST_MOVE_AP_FAIL:
			return {
				...state,
				loading: false,
				errorMessage: action.payload,
			};
		case RESET_MOVE_AP:
			return {
				...state,
				loading: false,
				successMsg: '',
				errorMessage: '',
			};
		default:
			return state;
	}
};

export const criticalAlarmTriggerReducer = (
	state = {
		criticalAlarmTriggered: false,
		critialAlarmsTriggerdHome: false,
		critialAlarmsTriggerdAp: false,
		critialAlarmsTriggerdSwitch: false,
		alarmsSummaryViewAllTriggerd: false
	},
	action
) => {
	switch (action.type) {
		case CRITICAL_ALARM_TRIGGER:
			return {
				...state,
				criticalAlarmTriggered: action.payload,
			};
		case CRITICAL_ALARM_TRIGGER_HOME:
			return {
				...state,
				critialAlarmsTriggerdHome: action.payload,
			};
		case CRITICAL_ALARM_TRIGGER_AP:
			return {
				...state,
				critialAlarmsTriggerdAp: action.payload,
			};
		case CRITICAL_ALARM_TRIGGER_SWITCH:
			return {
				...state,
				critialAlarmsTriggerdSwitch: action.payload,
			};
		case ALARM_SUMMARY_VIEW_ALL_TRIGGER:
			return {
				...state,
				alarmsSummaryViewAllTriggerd: action.payload,
			};
		default:
			return state;
	}
};
export const ApDashDownloadReducer = (
	state = { ApDashDownload: false, showApDownloadSuccessAlert: false },
	action
) => {
	switch (action.type) {
		case AP_DASH_DOWNLOAD:
			return {
				...state,
				ApDashDownload: action.payload,
			};
		case AP_DASH_DOWNLOAD_SUCCESS:
			return {
				...state,
				showApDownloadSuccessAlert: action.payload,
			};
		default:
			return state;
	}
};

export const apSwitchListReducer = (state = { users: {} }, action) => {
	switch (action.type) {
		case APSWITCH_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case APSWITCH_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				users: action.payload,
			};
		case APSWITCH_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const deviceListBySiteReducer = (state = { users: {} }, action) => {
	switch (action.type) {
		case DEVICE_REQUEST_BY_SITE_GET:
			return {
				...state,
				loading: true,
			};
		case DEVICE_RESPONSE_BY_SITE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				userslist: action.payload,
			};
		case DEVICE_RESPONSE_BY_SITE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

const apDashInitialState = {
	initiateApConfigData: { loading: false, data: null, error: null }, // Stores AP Configuration data
	downloadApConfigData: { loading: false, data: null, error: null }, // Stores Downloaded AP Configuration data
};
export const accessPointDashboardReducer = (
	state = apDashInitialState,
	action
) => {
	switch (action.type) {
		case GET_AP_CONFIG_REQUEST:
			return {
				...state,
				initiateApConfigData: {
					loading: true,
					data: null,
					error: null,
				},
			};

		case GET_AP_CONFIG_REQUEST_SUCCESS:
			return {
				...state,
				initiateApConfigData: {
					loading: false,
					data: action.payload,
					error: null,
				},
			};

		case GET_AP_CONFIG_REQUEST_FAIL:
			return {
				...state,
				initiateApConfigData: {
					loading: false,
					data: null,
					error: action.payload,
				},
			};

		case DOWNLOAD_AP_CONFIG_REQUEST:
			return {
				...state,
				downloadApConfigData: {
					loading: true,
					data: null,
					error: null,
				},
			};

		case DOWNLOAD_AP_CONFIG_REQUEST_SUCCESS:
			return {
				...state,
				downloadApConfigData: {
					loading: false,
					data: action.payload,
					error: null,
				},
			};

		case DOWNLOAD_AP_CONFIG_REQUEST_FAIL:
			return {
				...state,
				downloadApConfigData: {
					loading: false,
					data: null,
					error: action.payload,
				},
			};

		case RESET_AP_CONFIG_DATA:
			return {
				...state,
				initiateApConfigData: {
					loading: false,
					data: null,
					error: null,
				},
			};
		case RESET_DOWNLOAD_CONFIG_DATA:
			return {
				...state,
				downloadApConfigData: {
					loading: false,
					data: null,
					error: null,
				},
			};
		default:
			return state;
	}
};

export const configAuditListReducer = (state = { auditList: {} }, action) => {
	switch (action.type) {
		case CONFIG_AUDIT_LIST_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case CONFIG_AUDIT_LIST_GET_SUCCESS:
			return {
				...state,
				loading: false,
				auditList: action.payload,
			};
		case CONFIG_AUDIT_LIST_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const nestedChildListBySiteReducer = (state = { users: {} }, action) => {
	switch (action.type) {
		case CHILD_LIST_REQUEST_BY_SITE_GET:
			return {
				...state,
				loading: true,
			};
		case CHILD_LIST_RESPONSE_BY_SITE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				userslist: action.payload,
			};
		case CHILD_LIST_RESPONSE_BY_SITE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};